export default __webpack_public_path__ + "ffeb25f565a62356efde92971e1c9e93.png";